import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { setselectedPkgObj } from 'store/slice/EcomSlice';

import SelectPackage from './SelectPackage';
import SelectProduct from './SelectProduct';
import PrePaymentReview from './PrePaymentReview';
import Confirmation from './Confirmation';
import {setMlmUserObj, setPartnershipInitiationMode} from 'store/slice/EcomSlice';
import { setuserprofileInfo } from 'store/slice/HeaderSlice';
import { initPartnershipAPI } from 'api/CoreMlmmgmtWebServices';
import { setSelectedProductId } from 'store/slice/DmpSlice';


export default function InitPartnershipActionImpl(){
    const dispatch = useDispatch();
    const {selectedPkgObj,mlmUserObj} = useSelector((state) => state.ecomslice.mlm);
    const {userprofileInfo} = useSelector((state) => state.headerslice);
    const [stage, setStage] = useState('SELECT_PACKAGE');
    const {partnershipInitiationMode} = useSelector((state) => state.ecomslice.mlm);
    
    useEffect(() => {
        dispatch(setSelectedProductId(-1));
        setselectedPkgObj(null);
        dispatch(setPartnershipInitiationMode(true));
    }, []);
    
    
    useEffect(() => {
         console.log('stage=>'+stage);
         console.log('selectedPkgObj=>'+JSON.stringify(selectedPkgObj));
    },[selectedPkgObj]);
    
    useEffect(() => {
       
    },[mlmUserObj, stage]);


    const getComponent = () => {

        // console.log("InitPartnershipActionImpl==> selectedPkgObj=>", JSON.stringify(selectedPkgObj));
        // console.log("InitPartnershipActionImpl==> stage=>", JSON.stringify(stage));
        // console.log("InitPartnershipActionImpl==> userprofileInfo=>", JSON.stringify(userprofileInfo));
        // console.log("InitPartnershipActionImpl==> mlmUserObj=>", JSON.stringify(mlmUserObj));
        // console.log("mlmUserObj.partnershipstatus", mlmUserObj && (mlmUserObj.partnershipstatus == "CONFIRMED" && mlmUserObj.paymentid !== null));
        // User has not logged in yet and need to show package selection
        if (!selectedPkgObj || (selectedPkgObj && (selectedPkgObj.id===undefined || selectedPkgObj.id===-1))) {
            console.log("SELECT_PRODUCT");
            return <SelectProduct setStage={setStage}/>;
        }
           

        // New user is logged in but MLM user is not created yet
        if ((selectedPkgObj && selectedPkgObj.id!==undefined) && stage === 'PRE_PAYMENT_REVIEW')
            return <PrePaymentReview  setStage={setStage}/>;

        // User has made the payment
        if (partnershipInitiationMode && mlmUserObj && (mlmUserObj.partnershipstatus == "CONFIRMED")) {
            return <Confirmation />;
        }

        return <SelectProduct setStage={setStage}/>
        
    };  

    return (
        <>
        {getComponent()}
       
        </>
    )
}